import React, { memo, useEffect } from 'react';
import Card from '../components/Card';
// import SpeakerDoc from './SpeakerDoc';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { medwiki_static_image } from '../../../common/assets.common';
import { removeHtmlTags } from '../../../pages/channel/utils';
import LazyImage from '../../CustomLibraries/LazyImage';
import useRedirect from '../../customHooks/useRedirect';
import useShare from '../../customHooks/useShare';
import ReportContentPopover from './components/ReportContentPopover';
import { useOpenPixel } from '../../customHooks/useOpenPixel';
import { useTrackUserActivity } from '../../customHooks/useTrackUserActivity';
import InView from 'react-intersection-observer';
import TooltipContainer from '../components/TooltipContainer';

// #region constants

// #endregion

// #region styled-components

// #endregion

// #region functions

// #endregion

// #region component
const propTypes = {};

const defaultProps = {};

/**
 *
 */
const MedWikiCard = (data) => {
  const {
    type = '',
    className = '',
    sponsorLogo,
    id,
    question,
    specialities,
    deeplink,
    moduleType,
    image,
    likeCount,
    commentCount,
    viewCount,
    click,
    onLikePress,
    specialities_ids_and_names,
    featured = false,
    contentType,
    description
  } = data || {};
  const { redirectTo } = useRedirect();
  const share_url = useShare();
  const sponsor_logo = sponsorLogo ? sponsorLogo.split(',') : [];
  const { userActivityTracker } = useTrackUserActivity();
  const cardClick = () => (click ? click() : redirectTo('MedwikiDetails', id, question));

  const specialityClick = () => {
    // console.log('specialities_ids_and_names', specialities_ids_and_names);
    if (specialities_ids_and_names?.length > 0) {
      let { master_specialities_id, specialities_name } = specialities_ids_and_names[0];
      redirectTo('Speciality', master_specialities_id, specialities_name);
    }
  };
  return (
    <Card
      className={`clr_v3_card__medwiki cursorPointer ${className ?? ''} ${
        featured && 'clr_v3_card__featured'
      }`}
      type={type}
    >
      {/* comments and post by at top*/}
      {/* <CommentsAtTop /> */}

      {featured && (
        <span className="clr_v3_card__featured__tag bg-primary rounded-pill position-absolute text-white">
          <i className="clr_v3_card__featured__icon translate-middle start-50 top-50 position-absolute">
            <i className="flaticon-danger fs-1"></i>
          </i>
        </span>
      )}

      <Card.Body>
        <Card.Header>
          <div className="d-flex flex-column bd-highlight mb-3"></div>
          {/* <span
            className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer"
            onClick={specialityClick}
          >
            {specialities && <span>{specialities?.split(',')[0]}</span>}
            {specialityPopOver(specialities)}
          </span> */}

          {contentType && (
            <span className="clr_v3_card__icon d-inline-flex align-items-center justify-content-center me-auto cursorPointer gap-2">
              <i className="flaticon-medwiki fs-2 text-primary"></i>
              <span>{contentType}</span>
            </span>
          )}

          <div className="ms-auto align-items-center d-flex gap-sm-3 gap-2">
            <TooltipContainer text="Share">
              <span
                className="icon-size-32 icon-size-sm-36 clr_v3_card__icon transition cursorPointer flex-shrink-0 d-flex align-items-center justify-content-center rounded-pill rippleEffect position-relative fs-2 clr_v3_icon-btn-1"
                onClick={() => {
                  share_url(question, deeplink);
                }}
              >
                <i className="flaticon-share"></i>
              </span>
            </TooltipContainer>

            <ReportContentPopover type={moduleType} id={id} />
          </div>
        </Card.Header>
        <InView
          as="div"
          className="d-flex flex-column"
          onChange={(inView) => {
            userActivityTracker(inView, { ...data, type: 'comp', type_id: id }, 'card');
          }}
        >
          <div className="d-flex" onClick={cardClick}>
            {type == 'small' && (
              <div
                className="d-flex align-items-start flex-shrink-0 me-md-4 me-3 cursorPointer"
                // onClick={cardClick}
              >
                <Card.Image>
                  <LazyImage
                    src={image}
                    alt="banner"
                    fallback_image={medwiki_static_image}
                    className={`object-fit-cover w-100 h-100`}
                    // id={`medwikiCardV1_image_${cardmoduleType_id}`}
                    extraClass="hover-image w-100 h-100 position-relative"
                  />
                </Card.Image>
              </div>
            )}

            {question || description ? (
              <div className="flex-grow-1 d-flex justify-content-center flex-column">
                {question && (
                  <div
                    className="d-flex justify-content-center flex-column cursorPointer hover-opacity"
                    // onClick={cardClick}
                  >
                    <Card.Title className="hover-opacity">{removeHtmlTags(question)}</Card.Title>
                  </div>
                )}
                {type == 'small' && !isMobile && (
                  <Card.Description>{removeHtmlTags(description)}</Card.Description>
                )}
              </div>
            ) : (
              <></>
            )}
          </div>
          {type !== 'small' && (
            <div onClick={cardClick}>
              <Card.Image className="mt-4 cursorPointer">
                <LazyImage
                  src={image}
                  alt="banner"
                  fallback_image={medwiki_static_image}
                  className={`object-fit-cover w-100 h-100`}
                  extraClass="hover-image w-100 h-100 position-relative"
                  // id={`medwikiCardV1_image_${cardmoduleType_id}`}
                />
              </Card.Image>
            </div>
          )}

          <Card.Footer onClick={cardClick}>
            <div className="me-auto d-flex align-items-center flex-grow-1">
              <span
                className="clr_v3_card__icon opacity-50 text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center"
                // onClick={() => onLikePress('comp', id)}
              >
                <i class="flaticon-heart-1 me-2 fs-2"></i>
                {<span>{likeCount ?? 0}</span>}
              </span>
              <span
                className="clr_v3_card__icon opacity-50 text-dark py-1 me-4 me-sm-5 d-inline-flex align-items-center justify-content-center cursorPointer"
                onClick={cardClick}
              >
                <i class="flaticon-oval-black-speech-bubble me-2 fs-2"></i>
                {/* {<span>{commentCount ?? 0}</span>} */}
              </span>
              {/* <span className="clr_v3_card__icon opacity-50 text-dark py-1 d-inline-flex align-items-center justify-content-center">
              <i class="flaticon-eye me-2 fs-2"></i>
              {<span>{viewCount ?? 0}</span>}
            </span> */}
            </div>

            {sponsor_logo && sponsor_logo?.length > 0 ? (
              <Swiper
                className="clr_v3_sponsor text-right me-0"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsor_logo &&
                  sponsor_logo?.length > 1 &&
                  sponsor_logo?.map((_sp, idx) => (
                    <SwiperSlide
                      key={idx + 1}
                      className="clr_v3_sponsor_slide w-100 position-relative"
                    >
                      <LazyImage
                        src={_sp}
                        alt="sponsor"
                        className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                        logo
                      />
                    </SwiperSlide>
                  ))}
                {sponsor_logo &&
                  sponsor_logo?.length == 1 &&
                  sponsor_logo?.map((_sp, idx) => (
                    <div key={idx + 1} className="clr_v3_sponsor_slide w-100 position-relative">
                      <LazyImage
                        src={sponsor_logo[0]}
                        alt="sponsor"
                        className={`mw-100 mh-100 end-0 position-absolute translate-middle-y top-50`}
                        logo
                      />
                    </div>
                  ))}
              </Swiper>
            ) : (
              <div className="clr_v3_sponsor_slide w-100 position-relative"></div>
            )}
          </Card.Footer>
        </InView>
      </Card.Body>
      {/* card comments end */}
      {/* <CommentsAtEnd /> */}
    </Card>
  );
};

MedWikiCard.propTypes = propTypes;
MedWikiCard.defaultProps = defaultProps;
// #endregion

export default memo(MedWikiCard);
